module.exports = __webpack_public_path__ + "img/ic-shadow-controls.36b5201c.svg";